import React from 'react';

const Header = () => {

    return <h1>ComicBook</h1> 
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Atoms/text/Header/Header.js